import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import CardFooter from '../components/CardFooter.js';
import CardContent from '../components/CardContent.js';
import Card from '../Card.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["bullets", "buttonText", "columnSpan", "description", "discountDisplayType", "footerDescription", "headingLevel", "image", "imageOverlay", "imagePosition", "imageWidth", "ksps", "lazy", "onClick", "originalPrice", "originalPricePerPerson", "price", "pricePerPerson", "pricePerPersonFocus", "rating", "ratingPrefix", "showPriceFromPrefix", "subtitle", "tags", "title", "url"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CruiseCard = function CruiseCard(_ref) {
  var _ref$bullets = _ref.bullets,
    bullets = _ref$bullets === void 0 ? null : _ref$bullets,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
    _ref$columnSpan = _ref.columnSpan,
    columnSpan = _ref$columnSpan === void 0 ? 12 : _ref$columnSpan,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$discountDisplayT = _ref.discountDisplayType,
    discountDisplayType = _ref$discountDisplayT === void 0 ? 'original' : _ref$discountDisplayT,
    _ref$footerDescriptio = _ref.footerDescription,
    footerDescription = _ref$footerDescriptio === void 0 ? false : _ref$footerDescriptio,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? null : _ref$headingLevel,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$imageOverlay = _ref.imageOverlay,
    imageOverlay = _ref$imageOverlay === void 0 ? null : _ref$imageOverlay,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? 'left' : _ref$imagePosition,
    _ref$imageWidth = _ref.imageWidth,
    imageWidth = _ref$imageWidth === void 0 ? 6 : _ref$imageWidth,
    _ref$ksps = _ref.ksps,
    ksps = _ref$ksps === void 0 ? null : _ref$ksps,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$originalPrice = _ref.originalPrice,
    originalPrice = _ref$originalPrice === void 0 ? null : _ref$originalPrice,
    _ref$originalPricePer = _ref.originalPricePerPerson,
    originalPricePerPerson = _ref$originalPricePer === void 0 ? null : _ref$originalPricePer,
    _ref$price = _ref.price,
    price = _ref$price === void 0 ? null : _ref$price,
    _ref$pricePerPerson = _ref.pricePerPerson,
    pricePerPerson = _ref$pricePerPerson === void 0 ? null : _ref$pricePerPerson,
    _ref$pricePerPersonFo = _ref.pricePerPersonFocus,
    pricePerPersonFocus = _ref$pricePerPersonFo === void 0 ? false : _ref$pricePerPersonFo,
    _ref$rating = _ref.rating,
    rating = _ref$rating === void 0 ? null : _ref$rating,
    _ref$ratingPrefix = _ref.ratingPrefix,
    ratingPrefix = _ref$ratingPrefix === void 0 ? null : _ref$ratingPrefix,
    _ref$showPriceFromPre = _ref.showPriceFromPrefix,
    showPriceFromPrefix = _ref$showPriceFromPre === void 0 ? false : _ref$showPriceFromPre,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? null : _ref$tags,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Card, _objectSpread(_objectSpread({}, rest), {}, {
    columnSpan: columnSpan,
    imagePosition: imagePosition,
    imageWidth: imageWidth,
    image: image,
    lazy: lazy,
    imageOverlay: imageOverlay,
    onClick: onClick,
    url: url,
    children: [/*#__PURE__*/jsx(CardContent, {
      tags: tags,
      title: title,
      subtitle: subtitle,
      description: description,
      bullets: bullets,
      ksps: ksps,
      ratingPrefix: ratingPrefix,
      rating: rating,
      headingLevel: headingLevel
    }), /*#__PURE__*/jsx(CardFooter, {
      buttonText: buttonText,
      description: footerDescription,
      discountDisplayType: discountDisplayType,
      originalPrice: originalPrice,
      originalPricePerPerson: originalPricePerPerson,
      price: price,
      pricePerPerson: pricePerPerson,
      pricePerPersonFocus: pricePerPersonFocus,
      showPriceFromPrefix: showPriceFromPrefix,
      title: title
    })]
  }));
};
var CruiseCard$1 = CruiseCard;

export { CruiseCard$1 as default };
//# sourceMappingURL=CruiseCard.js.map
